/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'minus': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M512 96A416 416 0 1196 512 416.64 416.64 0 01512 96m0-96a512 512 0 10512 512A512 512 0 00512 0z" _fill="#515151"/><path pid="1" d="M768 560H256a48 48 0 010-96h512a48 48 0 010 96z" _fill="#515151"/>'
  }
})
